import { ToastContainer } from "react-toastify";
import { Box, Button, Paper, Typography, Grid, Tooltip } from "@mui/material";
import KpiFilters from "../components/KpiFilters";
import PaginatedTable from "../components/common/PaginatedTable";
import ChekedDropdown from "../components/common/CheckedDropdown";
import DownloadIcon from "@mui/icons-material/Download";
import WarningModal from "../components/common/WarningModalPopUp";
import { AdvancedFilters } from "../types/filters";
import { Dispatch, SetStateAction, useState } from "react";
import { buildParams } from "../Utils/buildParams";
import Dropdown from "../components/common/Dropdown";
import ConfirmationModalPopUp from "../components/common/ConfirmationModalPopUp";
import MomModalPopUp from "../components/common/MomModalPopUp";

interface PrimaryLandscapeSignOffPropTypes {
  openDraftDialog: boolean;
  setOpenDraftDialog: Dispatch<SetStateAction<boolean>>;
  openMomDialog: boolean;
  setOpenMomDialog: Dispatch<SetStateAction<boolean>>;
  dialogAction: "signoff" | "savecomments" | null;
  setDialogAction: Dispatch<SetStateAction<"signoff" | "savecomments" | null>>;
  validationErrors: Record<string, boolean>;
  showWarningModal: boolean;
  setShowWarningModal: Dispatch<SetStateAction<boolean>>;
  clearComments: () => void;
  closeWarningModal: () => void;
  filters: any;
  dropdownOptions: any; // Replace with your dropdown options type if available
  handleFilterChange: (
    key: keyof AdvancedFilters,
    value: string | string[]
  ) => void;
  thresholdValues: any; // Replace with your threshold values type if available
  currencyMode: string;
  setCurrencyMode: Dispatch<SetStateAction<string>>;
  currency: string;
  userData: any; // Replace with your user data type if available
  page: number;
  setPage: Dispatch<SetStateAction<number>>;
  order: string;
  orderBy: string;
  setOrder: React.Dispatch<React.SetStateAction<string>>;
  setOrderBy: Dispatch<SetStateAction<string>>;
  landscapeId: string;
  CBTType: string;
  tableData: any[];
  setTableData: Dispatch<SetStateAction<any[]>>;
  commentsArray: any[];
  setCommentsArray: Dispatch<SetStateAction<any[]>>;
  tableLoading: boolean;
  auditData: any[];
  totalAmountData: any[];
  isSignedOff: boolean;
  downloadCsv: (params: any) => void;
  filtersChanged: boolean;
  setFiltersChanged: Dispatch<SetStateAction<boolean>>;
  handleClick: () => void;
  signOffComments: string;
  setSignOffComments: Dispatch<SetStateAction<string>>;
  handleSignOff: (type: string) => Promise<void>;
  saveCommentsSignOff: () => Promise<void>;
  cbtTypeOptions: any[];
  companyCodeOptions: any[]; 
  L3CodeOptions: any[];
  cbtFilter: string;
  setCbtFilter: Dispatch<SetStateAction<string>>;
  companyFilter: string;
  setCompanyFilter: Dispatch<SetStateAction<string>>;
  glFilter: string;
  setGlFilter: Dispatch<SetStateAction<string>>;
  reportingGroupOptions: any[];
  rgFilter: string;
  setRgFilter: Dispatch<SetStateAction<string>>;
  handleTableFilterChange?: (
    value: string,
    key: "cbtFilter" | "companyFilter" | "glFilter" | "rgFilter"
  ) => void;
  momData: any;
}

const PrimaryLandscapeSignOff: React.FC<PrimaryLandscapeSignOffPropTypes> = ({
  openDraftDialog,
  setOpenDraftDialog,
  openMomDialog,
  setOpenMomDialog,
  dialogAction,
  setDialogAction,
  validationErrors,
  showWarningModal,
  setShowWarningModal,
  closeWarningModal,
  clearComments,
  filters,
  dropdownOptions,
  handleFilterChange,
  currencyMode,
  setCurrencyMode,
  handleClick,
  thresholdValues,
  currency,
  auditData,
  totalAmountData,
  isSignedOff,
  signOffComments,
  setSignOffComments,
  handleSignOff,
  saveCommentsSignOff,
  tableData,
  setTableData,
  setPage,
  page,
  commentsArray,
  setCommentsArray,
  tableLoading,
  filtersChanged,
  setFiltersChanged,
  order,
  orderBy,
  setOrder,
  setOrderBy,
  userData,
  landscapeId,
  CBTType,
  downloadCsv,
  cbtTypeOptions,
  companyCodeOptions,
  reportingGroupOptions,
  L3CodeOptions,
  cbtFilter,
  setCbtFilter,
  companyFilter,
  setCompanyFilter,
  glFilter,
  setGlFilter,
  rgFilter,
  setRgFilter,
  handleTableFilterChange,
  momData,
}) => {
  const [filtersVisible, setFiltersVisible] = useState(true);

   const handleGoAndCollapse = () => {
    handleClick();
    setFiltersVisible(false);
  };

  return (
    <>
      <ToastContainer />
      <ConfirmationModalPopUp
        openDraftDialog={openDraftDialog}
        setOpenDraftDialog={setOpenDraftDialog}
        saveAsDraft={async (type: string) => {
          if (type === "SAVE_COMMENTS") await saveCommentsSignOff();
          else await handleSignOff("SIGN_OFF");
        }}
        dialogAction={dialogAction}
      />
      <MomModalPopUp
        openMomDialog={openMomDialog}
        setOpenMomDialog={setOpenMomDialog}
        momData={momData}
        userData={userData}
        filters={filters}
        landscapeId={landscapeId}
        CBTType={CBTType}
      />
      <WarningModal
        open={showWarningModal}
        onClose={closeWarningModal}
        onConfirm={clearComments}
      />
      <div className="filters-container">
        <Box p={2}>
           {/* Centered shutter toggle strip — always rendered */}
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ width: "100%", mb: filtersVisible ? 0 : 1 }}
            >
              <Tooltip title={filtersVisible ? "Collapse Filters" : "Expand Filters"} placement="top">
                <Button
                  size="small"
                  onClick={() => setFiltersVisible((v) => !v)}
                  sx={{
                    minWidth: "56px",
                    width: "56px",
                    height: "14px",
                    padding: 0,
                    borderRadius: "0 0 10px 10px",
                    backgroundColor: "#0094f2",
                    color: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                    "&:hover": { backgroundColor: "#007acc" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <svg width="18" height="10" viewBox="0 0 24 12" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    {filtersVisible
                      ? <polyline points="4 8 12 2 20 8" />
                      : <polyline points="4 2 12 8 20 2" />
                    }
                  </svg>
                </Button>
              </Tooltip>
            </Box>
          {/* Dropdowns Block */}
          {filtersVisible && ( <Paper
            // className="paperDesign"
            elevation={1}
            sx={{ pl: 1, pr: 1, pt: 1, pb: 1, mb: 0, borderRadius: "10px" }}
          >
            <Grid container spacing={1}>
              {/* all dropdowns */}
              <Grid
                size={{ xs: 12, md: 7.5, sm: 7.5 }}
                sx={{ borderRight: "1px solid grey" }}
              >
                <Grid component="section">
                  {/* dropdowns top layer */}
                  <Grid container>
                    <Grid size={{ xs: 12, md: 1.5, sm: 1.5 }}>
                      <Grid component="section" className="userFilter">
                        <Dropdown
                          validationErrors={validationErrors}
                          filters={filters}
                          dropdownOptions={dropdownOptions}
                          handleFilterChange={handleFilterChange}
                          label="Market *"
                          disabled={commentsArray.length > 0}
                          filterKey="marketvalue"
                          className="marketDD"
                        />
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 1.5, sm: 1.5 }}>
                      <Grid component="section" className="userFilter">
                        <Dropdown
                          validationErrors={validationErrors}
                          filters={filters}
                          dropdownOptions={dropdownOptions}
                          handleFilterChange={handleFilterChange}
                          label="MCO *"
                          disabled={commentsArray.length > 0}
                          filterKey="mco"
                          className="marketDD"
                        />
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 2.5, sm: 2.5 }}>
                      <Grid component="section" className="userFilter">
                        <Dropdown
                          validationErrors={validationErrors}
                          filters={filters}
                          dropdownOptions={dropdownOptions}
                          handleFilterChange={handleFilterChange}
                          label="Country *"
                          disabled={commentsArray.length > 0}
                          filterKey="country"
                          className="countryDD"
                        />
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 3.75, sm: 3.75 }}>
                      <Grid
                        className="companyCodeDD userFilter"
                        component="section"
                      >
                        <label style={{ fontSize: "11px" }}>
                          Company Code *
                        </label>
                        <ChekedDropdown
                          key="companycodes"
                          multiple
                          label=""
                          value={
                            Array.isArray(filters.companycodes)
                              ? filters.companycodes
                              : [filters.companycodes]
                          }
                          isError={validationErrors.companycodes}
                          filterKey="companycodes"
                          options={dropdownOptions.companycodes}
                          filters={filters}
                          disabled={commentsArray.length > 0}
                          onChange={(value) =>
                            handleFilterChange("companycodes", value)
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid size={{ xs: 12, md: 2.75, sm: 2.75 }}>
                      <Grid component="section" className="userFilter">
                        <Dropdown
                          validationErrors={validationErrors}
                          filters={filters}
                          dropdownOptions={dropdownOptions}
                          handleFilterChange={handleFilterChange}
                          label="Review Scenario *"
                          disabled={commentsArray.length > 0}
                          filterKey="reviewscenario"
                          className="reviewScenarioDD"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* dropdowns bottom layer */}
                  <Grid container spacing={0.5}>
                    {/* balance sheet section */}
                    <Grid size={{ xs: 12, md: 5, sm: 5 }}>
                      <Grid component="section" size={{ md: 12 }}>
                        <Typography
                          align="center"
                          sx={{
                            mb: 0,
                            lineHeight: 1,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <strong>Balance Sheet:</strong>
                        </Typography>
                        <Box>
                          <Grid container spacing={0} className="userFilter">
                            <Grid size={{ xs: 12, md: 6, sm: 12 }}>
                              <Grid component="section">
                                <Typography align="center" sx={{ mb: 0 }}>
                                  <strong>Reporting</strong>
                                </Typography>
                                <Grid
                                  container
                                  spacing={0.25}
                                  sx={{ borderRight: "1px solid grey" }}
                                >
                                  <Grid size={{ xs: 12, md: 6.5, sm: 6.5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Year *"
                                        disabled={commentsArray.length > 0}
                                        filterKey="reportingyear"
                                        className="reportingYearDD"
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid size={{ xs: 12, md: 5, sm: 5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Period *"
                                        disabled={commentsArray.length > 0}
                                        filterKey="reportingmonth"
                                        className="reportingMonthDD"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 5.5, sm: 12 }}>
                              <Grid component="section">
                                <Typography align="center">
                                  <strong>Comparison</strong>
                                </Typography>
                                <Grid container spacing={0.5}>
                                  <Grid size={{ xs: 12, md: 6.5, sm: 6.5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Year *"
                                        disabled={commentsArray.length > 0}
                                        filterKey="comparisonyear"
                                        className="comparisonYearDD"
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid size={{ xs: 12, md: 5.5, sm: 5.5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Period *"
                                        disabled={commentsArray.length > 0}
                                        filterKey="comparisonmonth"
                                        className="comparisonMonthDD"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        height: "auto",
                        width: "1px",
                        backgroundColor: "#c1c1c1",
                        mt: "4px",
                        ml: "0px",
                      }}
                    />
                    {/* profit and loss section */}
                    <Grid size={{ xs: 12, md: 5, sm: 5 }}>
                      <Grid component="section" size={{ md: 12 }}>
                        <Typography
                          align="center"
                          sx={{
                            mb: 0,
                            lineHeight: 1,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <strong>Profit & Loss:</strong>
                        </Typography>
                        <Box>
                          <Grid container spacing={0} className="userFilter">
                            <Grid size={{ xs: 12, md: 6, sm: 12 }}>
                              <Grid component="section">
                                <Typography align="center" color="#a0b0c0" sx={{ mb: 0 }}>
                                  Reporting
                                </Typography>
                                <Grid
                                  container
                                  spacing={0.25}
                                  sx={{ borderRight: "1px solid grey" }}
                                >
                                  <Grid size={{ md: 6.5, sm: 6.5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Year *"
                                        boldLabel={false}
                                        //disabled={commentsArray.length > 0}
                                        disabled={true}
                                        filterKey="plreportingyear"
                                        className="reportingYearDD"
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid size={{ md: 5, sm: 5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Period *"
                                        boldLabel={false}
                                        //disabled={commentsArray.length > 0}
                                        disabled={true}
                                        filterKey="plreportingmonth"
                                        className="reportingMonthDD"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, md: 5.5, sm: 12 }}>
                              <Grid component="section">
                                <Typography align="center" color="#a0b0c0">
                                  Comparison
                                </Typography>
                                <Grid container spacing={0.5}>
                                  <Grid size={{ xs: 12, md: 6.5, sm: 6.5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Year *"
                                        boldLabel={false}
                                        //disabled={commentsArray.length > 0}
                                        disabled={true}
                                        filterKey="plcomparisonyear"
                                        className="comparisonYearDD"
                                      />
                                    </Grid>
                                  </Grid>
                                  <Grid size={{ xs: 12, md: 5.5, sm: 5.5 }}>
                                    <Grid component="section">
                                      <Dropdown
                                        validationErrors={validationErrors}
                                        filters={filters}
                                        dropdownOptions={dropdownOptions}
                                        handleFilterChange={handleFilterChange}
                                        label="Period *"
                                        boldLabel={false}
                                        //disabled={commentsArray.length > 0}
                                        disabled={true}
                                        filterKey="plcomparisonmonth"
                                        className="comparisonMonthDD"
                                      />
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>
                    {/*  */}
                    {/* Go and cancel Buttons */}
                    <Grid size={{ xs: 12, md: 1.75, sm: 1.75 }}>
                      <Grid component="section" sx={{ mt: 3.75 }}>
                        <Grid container spacing={2}>
                          <Grid size={{ xs: 12, md: 4, sm: 4 }}>
                            <Grid component="section">
                              <Button
                                className="gobtn"
                                size="small"
                                variant="contained"
                                disabled={commentsArray.length > 0}
                                color="primary"
                                onClick={handleGoAndCollapse}
                              >
                                GO
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid size={{ xs: 12, md: 6, sm: 12 }}>
                            <Grid component="section">
                              <Button
                                className="cancelbtn"
                                size="small"
                                variant="contained"
                                color="error"
                                onClick={() => {
                                  commentsArray.length > 0
                                    ? setShowWarningModal(true)
                                    : setShowWarningModal(false);
                                }}
                              >
                                Cancel
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Box
                    sx={{
                      height: "auto",
                      width: "1px",
                      backgroundColor: "#c1c1c1",
                      mt: "4px",
                      mx: "5px",
                    }}
                  />
                  {/*  */}
                </Grid>
              </Grid>

              {/* kpi filters */}
              <Grid size={{ xs: 12, md: 4.5, sm: 4.5 }}>
                <Grid component="section">
                  <KpiFilters
                    thresholdValues={thresholdValues}
                    currencyMode={currencyMode}
                    setCurrencyMode={setCurrencyMode}
                    currency={currency}
                    disabled={commentsArray.length > 0}
                    showToggle={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            {/* Separator */}
          </Paper>
          )}
          {/* Action Buttons */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={1}
          >
            {/* Validation Message */}
            <Box flex={1} pl={2}>
              <Box flex={1} pl={0}>
                <span>
                  {auditData[0]?.ValidationMessage ? (
                    <>
                      <Typography
                        className={
                          auditData[0]?.ValidationMessage.toLowerCase().includes(
                            "success"
                          )
                            ? "successMsg"
                            : "errorMsg"
                        }
                      >
                        {auditData[0]?.ValidationMessage}
                      </Typography>
                    </>
                  ) : tableData.length > 0 && filtersChanged ? (
                    <>
                      <Typography className={"errorMsg"}>
                        As Filters are modified, please click on "GO" button to
                        view the data.
                      </Typography>
                    </>
                  ) : (
                    ""
                  )}
                </span>
              </Box>
            </Box>
            <Box style={{ float: "right", marginRight: "8px" }}>
              <Button
                variant="contained"
                // startIcon={<DownloadIcon />}
                disabled={
                  (tableData.length === 0 &&
                    auditData[0].CommentsStatusID > 1) ||
                  filtersChanged || auditData[0].CommentsStatusID === 4
                }
                sx={{
                  backgroundColor: "#18B4FF",
                  color: "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "11px",
                  px: 2,
                  mr: 1,
                  "&:hover": { backgroundColor: "#0fa9f3" },
                }}
                onClick={() => setOpenMomDialog(true)}
              >
                MOM
              </Button>
              <Button
                variant="contained"
                disabled={tableData.length === 0 || filtersChanged || auditData[0].CommentsStatusID !== 3}
                sx={{
                  backgroundColor: "#0814A0",
                  color: "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "11px",
                  px: 2,
                  mr: 1,
                  "&:hover": { backgroundColor: "#0f20c5" },
                }}
                onClick={() => {
                  setDialogAction("savecomments");
                  setOpenDraftDialog(true);
                }}
              >
                Save Comments
              </Button>
              <Button
                variant="contained"
                startIcon={<DownloadIcon />}
                disabled={tableData.length === 0 || filtersChanged}
                sx={{
                  backgroundColor: "#18B4FF",
                  color: "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "11px",
                  px: 2,
                  "&:hover": { backgroundColor: "#0fa9f3" },
                }}
                onClick={() =>
                  downloadCsv({
                    ...buildParams(
                      filters,
                      userData,
                      currency,
                      page,
                      order,
                      orderBy,
                      landscapeId,
                      CBTType,
                      currencyMode
                    ),
                    MarketValue: filters.marketvalue,
                    MCO: filters.mco,
                    CommentsStatusID:
                      auditData.length > 0 ? auditData[0]?.CommentsStatusID : 0,
                  })
                }
              >
                Download
              </Button>
              {/* <Button
                variant="contained"
                startIcon={<RefreshIcon />}
                disabled={tableData.length === 0 || isSignedOff}
                sx={{
                  backgroundColor: "#18B4FF",
                  color: "white",
                  borderRadius: "20px",
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "11px",
                  ml: 1,
                  px: 2,
                  "&:hover": { backgroundColor: "#0fa9f3" },
                }}
              >
                Refresh
              </Button> */}
            </Box>
          </Box>
          <div style={{ clear: "both" }}></div>
          <div className="tableGrid">
            <PaginatedTable
              tableData={tableData}
              setTableData={setTableData}
              auditData={auditData[0]}
              filtersChanged={filtersChanged}
              totalAmountData={totalAmountData[0]}
              setPage={setPage}
              page={page}
              commentsArray={commentsArray}
              setCommentsArray={setCommentsArray}
              loading={tableLoading}
              order={order}
              orderBy={orderBy}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              commentsDisabled={!auditData[0]?.EnablePage}
              cbtTypeOptions={cbtTypeOptions}
              companyCodeOptions={companyCodeOptions}
              reportingGroupOptions={reportingGroupOptions}
              L3CodeOptions={L3CodeOptions}
              cbtFilter={cbtFilter}
              setCbtFilter={setCbtFilter}
              companyFilter={companyFilter}
              setCompanyFilter={setCompanyFilter}
              glFilter={glFilter}
              setGlFilter={setGlFilter}
              rgFilter={rgFilter}
              setRgFilter={setRgFilter}
              handleTableFilterChange={handleTableFilterChange}
              filtersVisible={filtersVisible}
            />
          </div>

          {/* Approval comments */}
          <div className="tableGrid">
            <Paper
              elevation={3}
              sx={{
                p: 1,
                mb: 5,
                mt: 0,
                borderRadius: "10px",
                boxShadow: "2px 2px 2px 2px #b5b5b5",
              }}
            >
              <Box display="flex" sx={{ mt: 0 }}>
                <Box flex={6} flexWrap="wrap" gap={1} mb={0}>
                  <h5>Preparer Sign-Off</h5>
                  <div className="preparer-sign-off">
                    <label className="app-header">
                      {" "}
                      TBR comments are updated for all the accounts under Review
                      required
                    </label>
                  </div>
                  <div className="flex">
                    <div className="app-header">
                      <div className="header-section">
                        <span className="label">
                          <label style={{ color: "#12239E" }}>
                            Company Codes:
                          </label>{" "}
                          {Array.isArray(filters.companycodes)
                            ? filters.companycodes.join(", ")
                            : filters.companycodes}
                        </span>
                      </div>
                    </div>
                  </div>
                </Box>
                <Box flex={6} flexWrap="wrap" gap={1} mb={0} ml={1}>
                  <h5>Sign-Off Comments (max. 4000 characters)</h5>
                  <div className="flex">
                    <div className="sign-off-comments">
                      <textarea
                        cols={100}
                        rows={5}
                        maxLength={4000}
                        disabled={tableData.length === 0 || isSignedOff}
                        style={{
                          resize: "vertical",
                          overflow: "auto",
                          width: "100%",
                          borderRadius: "10px",
                          minHeight: "100px", // ensures at least 5 lines visible
                          maxHeight: "310px", // optional: limit max height
                        }}
                        value={signOffComments}
                        onChange={(e) => setSignOffComments(e.target.value)}
                      ></textarea>
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        color="primary"
                        disabled={
                          tableData.length === 0 ||
                          isSignedOff ||
                          filtersChanged
                        }
                        sx={{ ml: 2, mt: 2, mr: 1, height: "80px" }}
                        onClick={() => {
                          setDialogAction("signoff");
                          setOpenDraftDialog(true);
                        }}
                      >
                        Sign&nbsp;Off
                      </Button>
                    </div>
                  </div>
                </Box>
              </Box>
            </Paper>
          </div>
        </Box>
      </div>
    </>
  );
};

export default PrimaryLandscapeSignOff;